import { useMemo } from "react";
import { useCookies } from "./useCookies.hook";
import useSessionStorageState from "./useSessionStorageState.hook";

export default function useGetRetailShopId() {
  const cookieValue = useCookies("shopRetailId");
  const [sessionValue] = useSessionStorageState<string>("shopRetailId");

  return useMemo(() => {
    const combined = sessionValue ?? cookieValue;

    if (!combined) return undefined;

    const [shopId, retailId] = combined.split("_");

    // Validate format - should be MongoDB ObjectIds (24 hex characters)
    if (!shopId || !retailId || !/^[a-f\d]{24}$/i.test(shopId) || !/^[a-f\d]{24}$/i.test(retailId)) {
      console.warn("Invalid shopRetailId format in useGetRetailShopId");
      return undefined;
    }

    return retailId;
  }, [sessionValue, cookieValue]);
}
